// selections.ts — Step 1d. Selection allowance-variance methods.
//
// Per-project allowance vs actual vs variance line items. See
// workers/core-os/src/routes/selections.ts (project_selections, migration
// 0005 + 0058).

import { request } from './request'

export interface SelectionRow {
  id: string
  project_id: string
  display_name: string
  category: string | null
  status: string
  allowance_amount_cents: number | null
  actual_amount_cents: number | null
  variance_cents: number | null
  client_decision_value: string | null
  notes: string | null
  created_at: string
  updated_at: string | null
}

export interface SelectionSummary {
  total_allowance_cents: number
  total_actual_cents: number
  total_variance_cents: number
  priced_count: number
  over_allowance_count: number
}

export interface SelectionListResponse {
  ok: true
  selections: SelectionRow[]
  count: number
  summary: SelectionSummary
}

export interface CreateSelectionInput {
  display_name: string
  category?: string
  status?: string
  allowance_amount_cents?: number | null
  actual_amount_cents?: number | null
  client_decision_value?: string
  notes?: string
}

export interface PatchSelectionInput {
  display_name?: string
  category?: string | null
  status?: string
  allowance_amount_cents?: number | null
  actual_amount_cents?: number | null
  client_decision_value?: string | null
  notes?: string | null
}

export const selectionsApi = {
  list: (projectId: string) =>
    request<SelectionListResponse>(
      `/api/projects/${encodeURIComponent(projectId)}/selections`,
    ),
  create: (projectId: string, body: CreateSelectionInput) =>
    request<{ ok: true; id: string; request_id: string }>(
      `/api/projects/${encodeURIComponent(projectId)}/selections`,
      { method: 'POST', body: JSON.stringify(body) },
    ),
  update: (projectId: string, selectionId: string, body: PatchSelectionInput) =>
    request<{ ok: true; id: string; updated: string[] }>(
      `/api/projects/${encodeURIComponent(projectId)}/selections/${encodeURIComponent(
        selectionId,
      )}`,
      { method: 'PATCH', body: JSON.stringify(body) },
    ),
}
